import * as tslib_1 from "tslib";
import * as React from 'react';
import { Button } from 'reactstrap';
/**
 * Button with support that will disable itself and optionally show different children when isExecuting is true.
 *
 * This button is designed primarily for use with async tasks where clicking the button should be disabled while a task is active.
 *
 * @param props
 */
export var ButtonAsync = function (props) {
    var isExecuting = props.isExecuting, children = props.children, executingChildren = props.executingChildren, disabled = props.disabled, rest = tslib_1.__rest(props, ["isExecuting", "children", "executingChildren", "disabled"]);
    var bestChildren = children;
    if (isExecuting && executingChildren) {
        bestChildren = executingChildren;
    }
    return (React.createElement(Button, tslib_1.__assign({ disabled: isExecuting || disabled }, rest), bestChildren));
};
//# sourceMappingURL=ButtonAsync.js.map